/* eslint-disable no-unused-vars */
export enum SuggestionStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}
